import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';
import { updateWhyHost2 } from '../../../../lib/graphql';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateWhyHost2,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === 200) {
    showToaster({ messageId: 'updateBlock3', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateBlockError3', toasterType: 'error' })
  }

}

export default submit;
